import React from 'react';
import { HeroCarousel } from '../components/home/HeroCarousel';
import { QuickActionBar } from '../components/home/QuickActionBar';
import { WhyChoose } from '../components/home/WhyChoose';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { AboutSection } from '../components/home/AboutSection';
import { AppointmentSection } from '../components/home/AppointmentSection';
import { MedicalAids } from '../components/home/MedicalAids';
export function Home() {
  return <div className="flex flex-col" data-id="element-696">
      <HeroCarousel data-id="element-697" />
      <QuickActionBar data-id="element-698" />
      <WhyChoose data-id="element-699" />
      <ServicesOverview data-id="element-700" />
      <AboutSection data-id="element-701" />
      <AppointmentSection data-id="element-702" />
      <MedicalAids data-id="element-703" />
    </div>;
}